<section class="main_catalogues_sec">
  <div class="wrapper outer_wrapper sec-padding">
    <section class="banner-container custom-continer" *ngIf="headerSlides?.length" style="border-radius: 20px;">
      <swiper [config]="headerBNSwiperConfig" class="banner-swiper">
        <div *ngFor="let banner of headerSlides" swiperSlide #headerSlide>
          <div class="banner-wrapper" style="background-color: transparent;">

            <a [href]="banner.url" target="_blank" rel="noopener noreferrer">
              <img class="banner-image" style="border-radius: 20px;" [src]="banner.img?.url" [alt]="banner.img.name"
                loading="eager" />
            </a>

            <div class="sponsored-label">
              <span class="info-icon">i</span> Sponsored
            </div>
          </div>
        </div>

        <div class="swiper-pagination"></div>
      </swiper>
    </section>
  </div>

  <section class="learning_sec sec-padding">
    <div class="wrapper outer_wrapper">
      <div class="Learning_row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
        <div fxLayout="column" fxFlex="20" fxFlex.lt-md="100" fxFlexFill>
          <div class="catalogues_left_column products_filter_column" fxFlexFill>
            <section class="listing_sticky_sec">
              <div class="learningHub_left_column">
                <div class="filters_box">
                  <div class="filter_head custom-filter_head">
                    <div class="search">Search By</div>
                    <button type="button" class="clear_btn" (click)="onClear()">CLEAR</button>
                  </div>
                  <div class="search-box">
                    <input type="text" class="search-input" placeholder="What are you looking for"
                      [(ngModel)]="currentSearch" (input)="onSearch($event.target.value)" />
                    <button class="search-btn">
                      <img src="../../../../../assets/images/icons/Icon akar-search.svg" alt="search icon"
                        loading="lazy" />
                    </button>
                  </div>
                </div>
                <div class="catalogues_filter_sec custom-filter_head">
                  <mat-accordion class="filter_mat_accordion">
                    <mat-expansion-panel [expanded]="true">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <div class="filter_head">
                            <h2>Filter by type</h2>
                          </div>
                        </mat-panel-title>
                      </mat-expansion-panel-header>

                      <div class="filters_box filter_checkbox">
                        <ul class="custom-check-box">
                          <!-- <li *ngFor="let typeName of getEventype">
                            <mat-checkbox [checked]="selectedTypes.includes(typeName)"
                              (change)="onTypeChange(typeName, $event.checked)">
                              {{ typeName }}
                            </mat-checkbox>
                          </li> -->
                          <li *ngFor="let typeName of getEventype">
                            <mat-checkbox [checked]="selectedTypes.includes(typeName)"
                              [disabled]="typeName === 'Online Academy'"
                              (change)="onTypeChange(typeName, $event.checked)"
                              [ngClass]="{'disabled-checkbox': typeName === 'Online Academy'}">
                              {{ typeName }}
                            </mat-checkbox>
                          </li>

                        </ul>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>

                  <mat-accordion class="filter_mat_accordion">
                    <mat-expansion-panel [expanded]="true">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <div class="filter_head">
                            <h2>Filter by Catagory</h2>
                          </div>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="filters_box filter_checkbox">
                        <ul class="custom-check-box">
                          <li *ngFor="let cat of getCatagoryType">
                            <mat-checkbox [checked]="selectedCategoryIds.includes(cat.id)"
                              (change)="onCategoryChange(cat.id, $event.checked)">
                              {{ cat.name }}
                            </mat-checkbox>
                          </li>
                        </ul>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                  <!-- <mat-accordion class="filter_mat_accordion">
                    <mat-expansion-panel [expanded]="true">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <div class="filter_head">
                            <h2>Filter by Speaker</h2>
                          </div>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="filters_box filter_checkbox">
                        <ul class="custom-check-box">
                          <li><mat-checkbox>Dr Sandeep</mat-checkbox></li>
                          <li><mat-checkbox>Lorem Ipsum</mat-checkbox></li>
                          <li><mat-checkbox>Webinar</mat-checkbox></li>
                        </ul>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion> -->

                    <!-- Filter by Communiries -->
                    <mat-accordion class="filter_mat_accordion" *ngIf="communityNames?.length > 0">
                      <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <div class="filter_head">
                              <h2 class="">Filter by Community </h2>
                            </div>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                    
                    
                        <div class="filter_box filter_checkbox">
                    
                          <ul *ngFor="let community of communityNames" class="custom-check-box">
                            <li>
                              <mat-checkbox [checked]="selectedCommunities.includes(community.community_id)"
                                (change)="onCommunityChange(community.community_id, $event.checked)">
                                {{ community.community_name }}
                              </mat-checkbox>
                            </li>
                          </ul>
                        </div>
                      </mat-expansion-panel>
                    </mat-accordion>

                  <mat-accordion class="filter_mat_accordion">
                    <mat-expansion-panel [expanded]="true">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <div class="filter_head filter_date" style="display: flex; align-items: center;">
                            <img src="../../../../../assets/images2/calendar-icon.png" alt="" width="16px" height="19px"
                              loading="lazy">
                            <h2>Filter by Date</h2>
                          </div>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="filters_box filter_checkbox">
                        <!-- <label for="dateInput" class="input-label">Select Date</label> -->
                        <div class="custom-input-wrapper">
                          <input id="dateInput" matInput [matDatepicker]="picker" [(ngModel)]="selectedDate"
                            (dateChange)="onDateChange($event.value)" (input)="onDateCleared($event)"
                            placeholder="Select date" class="custom-input" />
                          <mat-datepicker-toggle matSuffix [for]="picker"
                            class="datepicker-toggle"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                  <mat-accordion class="filter_mat_accordion">
                    <mat-expansion-panel [expanded]="true">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <div class="filter_head filter_loc">
                            <img src="../../../../../assets/images2/location-icon.png" alt="" width="16px" height="19px"
                              loading="lazy">
                            <h2>Filter by Location</h2>
                          </div>
                        </mat-panel-title>
                      </mat-expansion-panel-header>

                      <!-- Search Location -->
                      <div class="filters_box filter_checkbox">
                        <!-- <label for="locationInput" class="input-label">Search Location</label> -->
                        <div class="custom-input-wrapper">
                          <input matInput placeholder="Enter location" [(ngModel)]="selectedLocation"
                            (input)="onLocationChange($event.target.value)">
                          <button mat-icon-button matSuffix>
                            <mat-icon>search</mat-icon>
                          </button>
                        </div>
                      </div>

                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
              </div>
            </section>
          </div>

          <!-- <div class="addSection" *ngIf="leftNavBannerData?.length" style="margin-top: 20px;">
            <swiper [config]="leftNavBNSwiperConfig" class="banner-swiper">
              <div *ngFor="let banner of leftNavBannerData" swiperSlide #leftNavSlide>
                <div class="">

                  <a [href]="banner.url" target="_blank" rel="noopener noreferrer">
                    <img class="banner-image" [src]="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTvLCPETiGvNk0PEBF4vJfWoGVDsh69rcoAIA&s" [alt]="banner.img.name" />
                  </a>

                </div>
              </div>

              <div class="swiper-pagination"></div>
            </swiper>
          </div> -->
        </div>


        <div infiniteScroll [infiniteScrollDistance]="3" [infiniteScrollThrottle]="150"
          (scrolled)="getLearningHubData()" fxFlex fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="20px">

          <div class="learning_right_column">
            <div class=""
              style="height: 20px; border-bottom: 2px solid #ff7000; font-size: 15px; padding-bottom: 15px; font-weight: 600;">
              All RESOURCES</div>

            <div *ngIf="dataLoader" class="custom-loader custom_logo_loader no-datas">
            <img src='../../../../../assets/images2/loader.gif' alt="loading" style="width: 10%;" />
        </div>

              <ng-container *ngIf="!dataLoader">
            <div class="card-grid" *ngIf="learingHubList && learingHubList.length > 0; else noData">
              <!-- Repeat this block for each card -->

              <ng-container *ngFor="let course of learingHubList;let i = index; trackBy : trackBycourseId">

                <div class="custom-card" [routerLink]="['/learning/learning-hub-details', course?.id]"
                  [queryParams]="{ source: 'community_type' }">
                  <div> 
                  <div class="card-image-wrapper">
                    <ng-container *ngIf="course?.course_banner_image?.length; else noLogo">
                      <!-- <img class="talent-avatar" [src]="course.presented_by_image.url" alt="Course Image" loading="lazy"/> -->
                      <div class="swiper-container" *ngIf="course?.course_banner_image?.length">
                        <swiper [config]="bannerSwiperConfig">
                          <div *ngFor="let img of course?.course_banner_image" class="swiper-slide">
                            <img [src]="img?.url" alt="Slide image" />
                          </div>
                        </swiper>
                      </div>

                    </ng-container>

                    <ng-template #noLogo>
                      <div class="talent-avatar-placeholder"></div>
                    </ng-template>

                    <ng-container *ngIf="getSeatStatus(course) as status">
                      <div class="free-badge" *ngIf="status.type === 'sold'">
                        Sold Out
                      </div>

                      <div class="free-badge" *ngIf="status.type === 'hurry'">
                        Hurry Up! Only
                        <span class="count">{{ status.remaining }}</span> Seats Left
                      </div>

                      <div class="free-badge" *ngIf="status.type === 'fill'">
                        Filling Fast !
                      </div>
                    </ng-container>
                  </div>


                  <div style="display: flex; flex-direction: column;">
                    <div class="card-content">


                      <div class="title-row">
                        <div class="title-text">
                          {{course?.course_name}}
                        </div>


                        <div style="display: flex; gap: 10px;">

                          <div class="title-icon" [routerLink]=" ['/learning/learning-hub-details',course?.id]" [queryParams]="{ source: 'community_type' }">
                            <img src="../../../../../assets/images2/arrow-up.png" alt="Arrow Icon" loading="lazy" />
                          </div>

                          <div class="title-icon share-icon" (click)="shareCourse(course, $event)">
                            <mat-icon>share</mat-icon>
                          </div>



                        </div>
                      </div>

                      <hr />

                      <div class="presenter-row" *ngIf="course?.presenters?.length">
                          <div class="presenter-label">PRESENTED BY</div>

                          <!-- <swiper [config]="prsentersConfig" class="mySwiper">
                            <div *ngFor="let presenter of course.presenters" class="swiper-slide">
                              <img *ngIf="presenter?.presented_by_image?.url" class="presenter-img" [src]="presenter.presented_by_image.url" alt="Avatar"
                                loading="lazy" />
                                <span class="presenter-name">{{ presenter.presented_by_name || 'No Presenter' }}</span>
                            </div> 
                          </swiper> -->

                          <!-- <ng-template #noPresenters>
                                <div class="avatar"></div>
                            </ng-template> -->

                              <!-- <img class="talent-avatar" [src]="course.presented_by_image.url" alt="Course Image" loading="lazy"/> -->
                              <div class="presenter-container" *ngIf="course?.presenters?.length">
                                <swiper [config]="prsentersConfig">
                                  <div *ngFor="let presenter of course.presenters" class="swiper-slide presenter-slide">
                                   
                                    
                                    <img [src]="presenter?.presented_by_image?.url" alt="Slide image" />
                                    
                                    
                                    <span class="presenter-name"> {{presenter?.presented_by_name }}</span>
                                  </div>
                                </swiper>
                              </div>
                            

                    <ng-template #noLogo>
                      <div class="talent-avatar-placeholder"></div>
                    </ng-template>



                        </div>

                        

                        <hr *ngIf="course?.presenters?.length" />

                      <div class="card-details">

                        <div class="detail-address" *ngIf="course?.type">
                          <span class="detail-type">{{course?.type}}</span>
                        </div>

                        <div style="display: flex; justify-content: space-between; flex-wrap: wrap;">
                          <div class="detail-item" *ngIf="course?.cpd_points">
                            <mat-icon
                              style="vertical-align: middle; font-size: 19px; width: 18px; height: 18px; color: #A8A8A8;">schedule</mat-icon>
                            <span class="details-content">CPD HOURS :<b
                                style="color: #000; padding-left: 2px">{{course?.cpd_points}}</b></span>
                          </div>
                          <div class="detail-item" *ngIf="course?.startDate">
                            <img src="../../../../../assets/images2/calendar-icon.png" class="icon" width="16px"
                              height="19px" loading="lazy" />
                            <span class="details-content">{{ course?.startDate | date:'dd MMMM' }}</span>
                          </div>
                        </div>




                        <div class="detail-address" *ngIf="course?.address">
                          <img src="../../../../../assets/images2/location-icon.png" width="15px" height="20px"
                            class="icon" loading="lazy" style="padding-left: 3px;" />
                          <span class="detailsAddress-content">{{course?.address}}</span>
                        </div>
                      </div>


                    </div>
                   
                  </div>

                  </div>

                   <div style="padding:0px 13px 10px 13px;">
                      <button class="register-btn" [routerLink]="['/learning/learning-hub-details', course?.id]"
                        [queryParams]="{ scroll: 'appointments', source: 'community_type' }" >
                        REGISTER NOW
                        <img src="../../../../../assets/images2/right-arrow.png" alt="" loading="lazy">
                      </button>
                    </div>

                </div>

                <!-- Banner -->
                <div *ngIf="(i + 1) % 6 === 0 && listViewBannerData?.length" class="full-width-banner">
                  <section class="banner-container" style="padding: 20px 0;">
                    <swiper [config]="listViewRandomSwiperConfig(i)" class="banner-swiper">
                      <div *ngFor="let banner of listViewBannerData" swiperSlide #listViewSlide>
                        <div class="banner-wrapper1">
                          <a [href]="banner.url" target="_blank" rel="noopener noreferrer">
                            <img class="banner-image-list" style="border-radius: 20px;" [src]="banner.img?.url"
                              [alt]="banner.img.name" />
                          </a>
                          <div class="sponsored-label">
                            <span class="info-icon">i</span> Sponsored
                          </div>
                        </div>
                      </div>

                      <div class="swiper-pagination"></div>
                    </swiper>
                  </section>
                </div>

              </ng-container>
            </div>

              <div *ngIf="loading && learingHubList.length > 0" class="loading-more" fxLayout="row" fxLayoutAlign="center center">
                <img src="../../../../../assets/images2/loader.gif" alt="Loading more..." loading="lazy" width="80px" />
              </div>

            </ng-container>


            <app-share-popup [showPopup]="showSharePopup" [type]="shareType" [data]="shareData"
              (close)="showSharePopup = false">
            </app-share-popup>

            <ng-template #noData>
              <div class="no-data-wrapper">
                <img src="../../../../../assets/images/icons/no_tasks.svg" alt="No records illustration" class="no-data-image" />
                <div class="no-record-text">
                  No courses available at the moment
                </div>
              </div>
            </ng-template>

            <div *ngIf="endOfData && !loading && learingHubList.length > 0" class="text-center py-3 text-muted">
           You've reached the end — no more courses to display
        </div>


          </div>


        </div>

      </div>
    </div>
  </section>
</section>